import { isPseudoPlanID } from "../is-pseudo-plan-id";

import type { PlanRoomDailyRateRow } from "../types";

export type PlanGroupedRateMatrixRow = PlanRoomDailyRateRow & {
	/** 同じ planID の先頭行だけプラン名とプラン側バッジを出す */
	showPlanHeading: boolean;
};

/**
 * 未設定行の後ろ付けでも、同じプランの部屋が連続するように寄せる。
 * 「プランなし」（擬似プラン）は通常プランより前に置く。それ以外の初出順は元の並びに従う。
 */
export const groupRowsByPlanID = (rows: PlanRoomDailyRateRow[]): PlanGroupedRateMatrixRow[] => {
	const planOrder: string[] = [];
	const rowsByPlanID = new Map<string, PlanRoomDailyRateRow[]>();

	for (const row of rows) {
		const grouped = rowsByPlanID.get(row.planID);
		if (grouped == null) {
			planOrder.push(row.planID);
			rowsByPlanID.set(row.planID, [row]);
			continue;
		}
		grouped.push(row);
	}

	// API が旧順（プランなしが末尾）でも、確認しやすいよう擬似プランを先頭に寄せる
	const orderedPlanIDs = [
		...planOrder.filter((planID) => isPseudoPlanID(planID)),
		...planOrder.filter((planID) => !isPseudoPlanID(planID)),
	];

	return orderedPlanIDs.flatMap((planID) => {
		const grouped = rowsByPlanID.get(planID) ?? [];
		return grouped.map((row, index) => ({
			...row,
			showPlanHeading: index === 0,
		}));
	});
};
